<template>
    <div class="page-warp">
        <div class="mid-banner">
            <div class="mid-banner-item" v-if="bannerList.length">
                <img :src="bannerList[0].image" :title="bannerList[0].name" @click="goPage(bannerList[0])" />
            </div>
        </div>
        <div class="top-swiper">
            <Swipe class="my-swipe" :autoplay="3000" lazy-render>
                <SwipeItem v-for="image in swiperList" :key="'swiper_' + image.id">
                    <img :src="image.image" :title="image.name" @click="goPage(image)" />
                </SwipeItem>
            </Swipe>
        </div>
        <div class="bottom-pics">
            <div class="bottom-pics-item" v-for="image in iconList" :key="'icon_' + image">
                <img :src="image.image" :title="image.name" @click="goPage(image)" />
            </div>
        </div>
        <div class="about-us">
            <div>
                <span>联系我们 微信 Eleven931023</span>
                <span>工作时间 9:00-22:00</span>
            </div>
        </div>
    </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';
import { getBanners } from '../api/index.js'
export default {
    components: { Swipe, SwipeItem },
    data() {
        return {
            bannerList: [],
            swiperList: [],
            iconList: []
        }
    },
    mounted() {
        this.getBanners();
    },
    methods: {
        getBanners() {
            getBanners().then(res => {
                console.log(res)
                if(res.message == 'success') {
                    let list = res.data || []
                    let bannerList = []
                    let swiperList = []
                    let iconList = []
                    list.forEach(item => {
                        if(item.type == '1') {
                            bannerList.push(item)
                        } else if (item.type == '2') {
                            swiperList.push(item)
                        } else if (item.type == '3') {
                            iconList.push(item)
                        }
                    })
                    this.bannerList = bannerList
                    this.swiperList = swiperList
                    this.iconList = iconList
                }
            })
        },
        goPage(e) {
            if (e.link_type == '1') {
                return
            } else if (e.link_type == '2') {
                this.$router.push({path: e.out_url})
            } else if (e.link_type == '3') {
                window.location.href = e.out_url
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.page-warp {
    width: 100%;
    height: 100vh;
    background: #f0f0f0;
    overflow: auto;
    .top-swiper {
        width: 375px;
        height: 500px;
        margin-bottom: 10px;
        .my-swipe {
            width: 375px;
            height: 500px;
            img {
                width: 375px;
                height: 500px;
            }
        }
    }
    .mid-banner {
        width: 100vw;
        height: 56.25vw;
        margin-bottom: 10px;
        box-sizing: border-box;
        .mid-banner-item {
            width: 100vw;
            height: 56.25vw;
            margin-bottom: 10px;
            img {
                width: 100vw;
                height: 56.25vw;
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
    .bottom-pics {
        width: 375px;
        padding: 0 16px 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .bottom-pics-item {
            width: 75px;
            height: 75px;
            img {
                width: 75px;
                height: 75px;
            }
        }
    }
    .about-us {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 96px;
        div {
            color: #999aaa;
            font-size: 12px;
            line-height: 16px;
            span {
                margin: 0 16px;
            }
        }
    }
}
.my-swipe .van-swipe-item {
    width:  100%;
    height: 200px;
    img {
        width: 100%;
        height: 200px;
    }
}
</style>
